import React from 'react'

import { Stack, Typography } from '@mui/material'

import { theme } from 'styles/theme'

export interface EmptyStateProps {
  title?: string
  message?: string
  minHeight?: string | number
}
const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'Nenhum dado foi encontrado',
  message = 'Tente ajustar os filtros ou cadastre um novo item para começar a visualizar as informações por aqui.',
  minHeight
}) => {
  return (
    <Stack
      gap="8px"
      justifyContent="center"
      alignItems="center"
      direction="column"
      width="100%"
      minHeight={minHeight}
      padding="50px 0px"
      borderRadius="10px"
      border={`1px solid ${theme.palette.neutral[700]}`}
    >
      {title && (
        <Typography variant="mdLight" color={theme.palette.neutral[200]}>
          {title}
        </Typography>
      )}
      {message && (
        <Typography
          maxWidth="28rem"
          variant="smLight"
          textAlign="center"
          color={theme.palette.neutral[400]}
        >
          {message}
        </Typography>
      )}
    </Stack>
  )
}

export default EmptyState
